import { useDAL } from '@/contexts/useDAL';
export const useOrgsAndFolders = () => {
  const dal = useDAL();
  const {
    data: orgsData,
    isLoading: orgsLoading,
    mutate: mutateOrgs
  } = dal.cloudAccounts.gcpOrganization.useList();
  const {
    data: foldersData,
    isLoading: foldersLoading,
    mutate: mutateFolders
  } = dal.cloudAccounts.gcpFolder.useList();
  const orgsAndFolders = [...(orgsData?.organizations || []), ...(foldersData?.folders || [])];
  const isLoading = orgsLoading || foldersLoading;
  const mutate = () => Promise.all([mutateOrgs(), mutateFolders()]);
  return {
    orgsAndFolders,
    isLoading,
    mutate
  };
};